(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'resize', 'mousemove'];
(window as any).__Zone_disable_requestAnimationFrame = true;
